import { get } from "lodash"
import Invoices from "../layouts/Invoices"

export default function wrapPageElement({ element, props }, _options) {
  if (get(props, "pageContext.wrapperLayout") !== "Invoices") {
    return element
  }

  // Na podstronach niepowodzenie/dziekujemy CheckoutContext jest zbędny bo działamy na oldToken
  return <Invoices {...props}>{element}</Invoices>
}
